
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/award-winners",
      function () {
        return require("private-next-pages/award-winners.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/award-winners"])
      });
    }
  